import { useDataValue, useDataSubmit } from 'Simple/Data.js'
import { isUnscheduledAppointment, timeToMinutes } from 'Data/format.js'

export function useOnClick(props) {
  let option = useDataValue({
    context: 'option',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'appointment_overlay',
    viewPath: props.viewPath,
  })
  let appointments = useDataValue({
    context: 'appointments',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (option.isSelected || option.isDisabled) return

    if (option.id === 'new') {
      let newAppointment = appointments.find(item => item.id === 'new')
      return submit({
        type: 'setNewAppointment',
        approximateDate: newAppointment?.approximateDate ?? null,
      })
    } else {
      let existingAppointments = appointments.filter(item => item.id !== 'new')
      if (!existingAppointments.length) return

      let [preferred] = existingAppointments.filter(item =>
        isUnscheduledAppointment(item)
      )
      if (!preferred) preferred = existingAppointments[0]

      let is_unscheduled = isUnscheduledAppointment(preferred)
      let booking = !is_unscheduled ? preferred.booking?.[0] : null
      let location = !is_unscheduled
        ? booking.location
        : preferred.tx.organization

      return submit({
        type: 'setExistingAppointment',
        id: preferred._id,
        type_id: preferred.type._id,
        type_name: preferred.type.display_name,
        treatment_id: preferred.tx._id,
        duration: booking ? booking.duration : preferred.duration,
        approximateDate: preferred.approximateDate,
        location: {
          id: location._id,
          vaxiom_id: location.id,
          name: location.name,
          time_zone_id: location.time_zone_id,
        },
        booking: booking
          ? {
              start_min: timeToMinutes(booking.local_start_time),
              date: booking.local_start_date,
              chair_id: booking.chair._id,
              chair_name: booking.chair.full_name,
              location_id: booking.chair.resource.organization._id,
            }
          : null,
      })
    }
  }
}
